import type { Case } from '../store/api/casesApi'

/**
 * Format case display with prefix: <Mã cuộc thi> - <Tên cuộc thi>
 */
export function formatCaseDisplay(caseItem: Case): string {
  if (caseItem.case_number) {
    return `${caseItem.case_number} - ${caseItem.title}`
  }
  return caseItem.title
}
